const triggers = [
  {
    svg: 'square_check',
    code: 'affiliate_created',
    title: 't(Affiliate Created)',
    text: 't(Contact\'s joined affiliate program)',
    access: { rights: { $allOf: ['truevail:access_admin'] } }
  },
  {
    svg: 'square_check',
    code: 'payout_issued',
    title: 't(Affiliate Payout Issued)',
    text: 't(Contact\'s affiliate payout was issued)',
    access: { rights: { $allOf: ['truevail:access_admin'] } }
  },
  {
    svg: 'square_check',
    code: 'referral_team_created',
    title: 't(Referral Team Created)',
    text: 't(Contact\'s referral\'s team was created)',
    access: { rights: { $allOf: ['truevail:access_admin'] } }
  },
  {
    svg: 'square_check',
    code: 'referral_trial_started',
    title: 't(Referral Trial Subscription Started)',
    text: 't(Contact\'s referral\'s trial subscription started)',
    access: { rights: { $allOf: ['truevail:access_admin'] } }
  },
  {
    svg: 'square_check',
    code: 'referral_trial_ended',
    title: 't(Referral Trial Subscription Ended)',
    text: 't(Contact\'s referral\'s trial subscription ended)',
    access: { rights: { $allOf: ['truevail:access_admin'] } }
  },
  {
    svg: 'square_check',
    code: 'referral_subscription_canceled',
    title: 't(Referral Subscription Canceled)',
    text: 't(Contact\'s referral\'s subscription was canceled)',
    access: { rights: { $allOf: ['truevail:access_admin'] } }
  },
  {
    svg: 'square_check',
    code: 'signup_created',
    title: 't(Signup Created)',
    text: 't(Contact created a new signup through signup page)',
    access: { rights: { $allOf: ['truevail:access_admin'] } }
  },
  {
    svg: 'square_check',
    code: 'signup_cart_duration',
    title: 't(Signup Cart Duration)',
    text: 't(Contact has an incomplete signup cart for a specific duration)',
    access: { rights: { $allOf: ['truevail:access_admin'] } }
  },
  {
    svg: 'square_check',
    code: 'team_status_duration',
    title: 't(Team Status Duration)',
    text: 't(Contact\'s team had a specific status for a specific duration)',
    access: { rights: { $allOf: ['truevail:access_admin'] } }
  },
  {
    svg: 'square_check',
    code: 'team_status_transitioned',
    title: 't(Team Status Transitioned)',
    text: 't(Contact\'s team was transitioned from one status to another)',
    access: { rights: { $allOf: ['truevail:access_admin'] } }
  }
]

export default triggers
